var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { s as checkUserMetricWriteAccessEpicReducer, t as loadExperimentationGroupsWithMetricWriteEpicReducer, u as loadAllExperimentationGroupsEpicReducer, w as createMetricSetEpicReducer, x as createMetricSetInstanceEpicReducer, y as cloneMetricSetEpicReducer, z as deleteMetricSetEpicReducer, A as loadMetricSetsEpicReducer, B as loadMetricSetInstanceStatusEpicReducer, c as loadMetricSetDraftsEpicReducer, C as loadMetricSetDraftHistoryEpicReducer, g as loadMetricSetDraftRawColumnsEpicReducer, f as loadMetricSetDraftAggregationLevelsEpicReducer, D as loadMetricSetDraftExperimentationConfigEpicReducer, E as loadMetricSetDraftMetadataEpicReducer, l as loadProductionHistoryEpicReducer, b as loadProductionMetaDataEpicReducer, F as loadScorecardLayoutsEpicReducer, k as loadComputationTemplatesEpicReducer, m as loadComputationTemplateInstancesEpicReducer, n as loadMetricsForCompuatationTemplateInstancesEpicReducer, G as createMetricSetDraftEpicReducer, e as deleteMetricSetDraftEpicReducer, H as mergeMetricSetDraftEpicReducer, I as validateMetricSetDraftEpicReducer, J as getValidateResultEpicReducer, K as publishMetricSetDraftEpicReducer, L as loadPublishStatusEpicReducer, M as loadMetricHealthResultsEpicReducer, N as loadMetricSetConfigEpicReducer, O as updateMetricSetConfigEpicReducer, P as loadMetricSetMainAggregationLevelsEpicReducer, Q as loadWorkspaceConfigEpicReducer, R as deleteSegmentEpicReducer, S as loadSegmentsEpicReducer, h as loadComputationFilePathsEpicReducer, i as loadColumnsEpicReducer, j as loadMetricsEpicReducer, p as createSegmentEpicReducer, T as loadPublishedVersionsEpicReducer, U as loadRecentPreviewAnalysisEpicReducer, V as loadExperimentEpicReducer, W as loadRecentExperimentsEpicReducer, X as loadFeatureProgressionsEpicReducer, Y as loadRecentFeaturesEpicReducer, Z as loadDefaultExperimentsEpicReducer, _ as loadDefaultFeaturesEpicReducer, $ as loadFeaturesForExperimentationGroupEpicReducer, a0 as loadExperimentsForExperimentationGroupEpicReducer, a1 as putComputationsEpicReducer, a2 as loadSelectedSegmentEpicReducer, a3 as loadExperimentStepPlanSummariesEpicReducer, a4 as validateExperimentStepsEpicReducer, o as loadColumnDetailsEpicReducer, a5 as updateMergeStatusMetricSetDraftEpicReducer, a6 as updatePublishStatusMetricSetDraftEpicReducer, a7 as loadMetricSetInstanceLatestStatusEpicReducer, a8 as METRICS_REDUCER_KEYS, a9 as ACTION_TYPES$1 } from "../../Vivace.epics-e2cdc8fc.js";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadMetricDetailsEpicReducer, putComputationsWithUpdatesEpicReducer, getNewTemplateInstancesEpicReducer, putComputationsWithAdditionalUpdatesEpicReducer, getMetricsInNewTemplateInstanceEpicReducer, getScorecardLayoutPathsEpicReducer, getScorecardLayoutsEpicReducer, putScorecardLayoutFilesEpicReducer, createMetricEpicReducer, createComutationTemplateInstanceEpicReducer, quickCompileEpicReducer, quickComputeEpicReducer, loadQuickValidationResultEpicReducer, cancelQuickValidationEpicReducer, checkQuickValidateEpicReducer, loadDraftDatasourceEpicReducer, loadDatasourceDetailsEpicReducer, ACTION_TYPES } from "./Metric/Metric.epics.js";
const getDefaultState = () => ({
  global: {
    experimentation_groups_with_metric_write: getDefaultAsyncWrapperObj(),
    experimentation_groups: getDefaultAsyncWrapperObj(),
    user_access: {},
    user_metric_write_access: {}
  },
  metric_sets: {
    list: getDefaultAsyncWrapperObj(),
    create: getDefaultAsyncWrapperObj(),
    clone: getDefaultAsyncWrapperObj(),
    delete: getDefaultAsyncWrapperObj(),
    workspace_config: getDefaultAsyncWrapperObj(),
    metric_set_instance_create: getDefaultAsyncWrapperObj(),
    metric_set_instance_status: getDefaultAsyncWrapperObj(),
    metric_set_instance_latest_status: getDefaultAsyncWrapperObj()
  },
  drafts: {
    meta_data: getDefaultAsyncWrapperObj(),
    history: getDefaultAsyncWrapperObj(),
    list: getDefaultAsyncWrapperObj(),
    create: getDefaultAsyncWrapperObj(),
    delete: getDefaultAsyncWrapperObj(),
    metric_set_config: getDefaultAsyncWrapperObj(),
    metric_set_config_update: getDefaultAsyncWrapperObj(),
    aggregation_levels: getDefaultAsyncWrapperObj()
  },
  draft: {
    history: getDefaultAsyncWrapperObj(),
    raw_columns: getDefaultAsyncWrapperObj(),
    aggregation_levels: getDefaultAsyncWrapperObj(),
    experiment_config: getDefaultAsyncWrapperObj(),
    meta_data: getDefaultAsyncWrapperObj(),
    scorecard_layouts: getDefaultAsyncWrapperObj(),
    computation_templates: getDefaultAsyncWrapperObj(),
    computation_template_instances: getDefaultAsyncWrapperObj(),
    computation_template_instance_metrics: getDefaultAsyncWrapperObj(),
    scorecard_layout_paths: {},
    merge: getDefaultAsyncWrapperObj(),
    merge_update: getDefaultAsyncWrapperObj(),
    validate: getDefaultAsyncWrapperObj(),
    validate_result: getDefaultAsyncWrapperObj(),
    metrics: {
      user_context: {
        metric: null,
        query: null
      },
      metric_wizard: {
        metadata: null,
        metric_details: getDefaultAsyncWrapperObj(),
        create_get: getDefaultAsyncWrapperObj(),
        create_put: getDefaultAsyncWrapperObj(),
        quick_compile_put: getDefaultAsyncWrapperObj(),
        quick_compute_put: getDefaultAsyncWrapperObj(),
        quick_compute_get: getDefaultAsyncWrapperObj(),
        quick_compute_cancel: getDefaultAsyncWrapperObj(),
        quick_compute_check: getDefaultAsyncWrapperObj(),
        custom_dimensions: {},
        datasource_get: getDefaultAsyncWrapperObj(),
        datasource_details_get: getDefaultAsyncWrapperObj()
      },
      list: getDefaultAsyncWrapperObj()
    },
    metric_health: {
      stat_sig_check: getDefaultAsyncWrapperObj()
    },
    publish: getDefaultAsyncWrapperObj(),
    publish_update: getDefaultAsyncWrapperObj(),
    publish_status: getDefaultAsyncWrapperObj(),
    published_versions: getDefaultAsyncWrapperObj(),
    recent_preview_analyses: getDefaultAsyncWrapperObj(),
    experiment: getDefaultAsyncWrapperObj(),
    recent_experiments: getDefaultAsyncWrapperObj(),
    feature_progressions: getDefaultAsyncWrapperObj(),
    recent_features: getDefaultAsyncWrapperObj(),
    default_experiments: getDefaultAsyncWrapperObj(),
    default_features: getDefaultAsyncWrapperObj(),
    experimentation_group_features: getDefaultAsyncWrapperObj(),
    experimentation_group_experiments: getDefaultAsyncWrapperObj(),
    experiment_plan_summaries: getDefaultAsyncWrapperObj(),
    experiment_steps_validate_result: getDefaultAsyncWrapperObj(),
    segments: {
      list: getDefaultAsyncWrapperObj(),
      load: getDefaultAsyncWrapperObj(),
      create_get: getDefaultAsyncWrapperObj(),
      create_put: getDefaultAsyncWrapperObj(),
      delete: getDefaultAsyncWrapperObj()
    },
    computation_file_paths: getDefaultAsyncWrapperObj(),
    columns: {
      list: getDefaultAsyncWrapperObj(),
      load: getDefaultAsyncWrapperObj()
    }
  }
});
const MauiReducer = (state = getDefaultState(), actionResult) => {
  var _a, _b, _c, _d, _e, _f, _g;
  state = checkUserMetricWriteAccessEpicReducer.reduxChange(state, actionResult);
  state = loadExperimentationGroupsWithMetricWriteEpicReducer.reduxChange(state, actionResult);
  state = loadAllExperimentationGroupsEpicReducer.reduxChange(state, actionResult);
  state = createMetricSetEpicReducer.reduxChange(state, actionResult);
  state = createMetricSetInstanceEpicReducer.reduxChange(state, actionResult);
  state = cloneMetricSetEpicReducer.reduxChange(state, actionResult);
  state = deleteMetricSetEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetsEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetInstanceStatusEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetDraftsEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetDraftHistoryEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetDraftRawColumnsEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetDraftAggregationLevelsEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetDraftExperimentationConfigEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetDraftMetadataEpicReducer.reduxChange(state, actionResult);
  state = loadProductionHistoryEpicReducer.reduxChange(state, actionResult);
  state = loadProductionMetaDataEpicReducer.reduxChange(state, actionResult);
  state = loadScorecardLayoutsEpicReducer.reduxChange(state, actionResult);
  state = loadComputationTemplatesEpicReducer.reduxChange(state, actionResult);
  state = loadComputationTemplateInstancesEpicReducer.reduxChange(state, actionResult);
  state = loadMetricsForCompuatationTemplateInstancesEpicReducer.reduxChange(state, actionResult);
  state = createMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = deleteMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = mergeMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = validateMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = getValidateResultEpicReducer.reduxChange(state, actionResult);
  state = publishMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = loadPublishStatusEpicReducer.reduxChange(state, actionResult);
  state = loadMetricHealthResultsEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetConfigEpicReducer.reduxChange(state, actionResult);
  state = updateMetricSetConfigEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetMainAggregationLevelsEpicReducer.reduxChange(state, actionResult);
  state = loadWorkspaceConfigEpicReducer.reduxChange(state, actionResult);
  state = deleteSegmentEpicReducer.reduxChange(state, actionResult);
  state = loadSegmentsEpicReducer.reduxChange(state, actionResult);
  state = loadComputationFilePathsEpicReducer.reduxChange(state, actionResult);
  state = loadColumnsEpicReducer.reduxChange(state, actionResult);
  state = loadMetricsEpicReducer.reduxChange(state, actionResult);
  state = createSegmentEpicReducer.reduxChange(state, actionResult);
  state = loadPublishedVersionsEpicReducer.reduxChange(state, actionResult);
  state = loadRecentPreviewAnalysisEpicReducer.reduxChange(state, actionResult);
  state = loadExperimentEpicReducer.reduxChange(state, actionResult);
  state = loadRecentExperimentsEpicReducer.reduxChange(state, actionResult);
  state = loadFeatureProgressionsEpicReducer.reduxChange(state, actionResult);
  state = loadRecentFeaturesEpicReducer.reduxChange(state, actionResult);
  state = loadDefaultExperimentsEpicReducer.reduxChange(state, actionResult);
  state = loadDefaultFeaturesEpicReducer.reduxChange(state, actionResult);
  state = loadFeaturesForExperimentationGroupEpicReducer.reduxChange(state, actionResult);
  state = loadExperimentsForExperimentationGroupEpicReducer.reduxChange(state, actionResult);
  state = putComputationsEpicReducer.reduxChange(state, actionResult);
  state = loadSelectedSegmentEpicReducer.reduxChange(state, actionResult);
  state = loadMetricDetailsEpicReducer.reduxChange(state, actionResult);
  state = putComputationsWithUpdatesEpicReducer.reduxChange(state, actionResult);
  state = getNewTemplateInstancesEpicReducer.reduxChange(state, actionResult);
  state = putComputationsWithAdditionalUpdatesEpicReducer.reduxChange(state, actionResult);
  state = getMetricsInNewTemplateInstanceEpicReducer.reduxChange(state, actionResult);
  state = getScorecardLayoutPathsEpicReducer.reduxChange(state, actionResult);
  state = getScorecardLayoutsEpicReducer.reduxChange(state, actionResult);
  state = putScorecardLayoutFilesEpicReducer.reduxChange(state, actionResult);
  state = createMetricEpicReducer.reduxChange(state, actionResult);
  state = createComutationTemplateInstanceEpicReducer.reduxChange(state, actionResult);
  state = quickCompileEpicReducer.reduxChange(state, actionResult);
  state = quickComputeEpicReducer.reduxChange(state, actionResult);
  state = loadQuickValidationResultEpicReducer.reduxChange(state, actionResult);
  state = cancelQuickValidationEpicReducer.reduxChange(state, actionResult);
  state = checkQuickValidateEpicReducer.reduxChange(state, actionResult);
  state = loadDraftDatasourceEpicReducer.reduxChange(state, actionResult);
  state = loadDatasourceDetailsEpicReducer.reduxChange(state, actionResult);
  state = loadExperimentStepPlanSummariesEpicReducer.reduxChange(state, actionResult);
  state = validateExperimentStepsEpicReducer.reduxChange(state, actionResult);
  state = loadColumnDetailsEpicReducer.reduxChange(state, actionResult);
  state = updateMergeStatusMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = updatePublishStatusMetricSetDraftEpicReducer.reduxChange(state, actionResult);
  state = loadMetricSetInstanceLatestStatusEpicReducer.reduxChange(state, actionResult);
  switch (actionResult.type) {
    case ACTION_TYPES$1.METRIC_SETS.RESET_CREATE:
      return __spreadProps(__spreadValues({}, state), {
        metric_sets: __spreadProps(__spreadValues({}, state.metric_sets), {
          create: getDefaultAsyncWrapperObj(),
          metric_set_instance_create: getDefaultAsyncWrapperObj(),
          metric_set_instance_status: getDefaultAsyncWrapperObj()
        })
      });
    case ACTION_TYPES$1.METRIC_SETS.RESET_DELETE:
      return __spreadProps(__spreadValues({}, state), {
        metric_sets: __spreadProps(__spreadValues({}, state.metric_sets), {
          delete: getDefaultAsyncWrapperObj()
        })
      });
    case ACTION_TYPES$1.METRIC_SETS.RESET_CLONE:
      return __spreadProps(__spreadValues({}, state), {
        metric_sets: __spreadProps(__spreadValues({}, state.metric_sets), {
          clone: getDefaultAsyncWrapperObj()
        })
      });
    case ACTION_TYPES$1.METRIC_SETS.REMOVE:
      {
        const data = (_a = state.metric_sets.list) == null ? void 0 : _a.data;
        if (data) {
          const index = data == null ? void 0 : data.findIndex((item) => item.metricSet === actionResult.payload);
          return __spreadProps(__spreadValues({}, state), {
            metric_sets: __spreadProps(__spreadValues({}, state.metric_sets), {
              list: __spreadProps(__spreadValues({}, state.metric_sets.list), {
                data: [...data.slice(0, index), ...data.slice(index + 1)]
              })
            })
          });
        }
      }
      break;
    case ACTION_TYPES$1.DRAFTS.RESET_META_DATA:
      {
        const data = (_b = state.drafts.meta_data) == null ? void 0 : _b.data;
        if (data) {
          return __spreadProps(__spreadValues({}, state), {
            drafts: __spreadProps(__spreadValues({}, state.drafts), {
              meta_data: getDefaultAsyncWrapperObj()
            })
          });
        }
      }
      break;
    case ACTION_TYPES$1.DRAFTS.RESET_HISTORY:
      {
        const data = (_c = state.drafts.history) == null ? void 0 : _c.data;
        if (data) {
          return __spreadProps(__spreadValues({}, state), {
            drafts: __spreadProps(__spreadValues({}, state.drafts), {
              history: getDefaultAsyncWrapperObj()
            })
          });
        }
      }
      break;
    case ACTION_TYPES$1.DRAFTS.RESET_CREATE:
      return __spreadProps(__spreadValues({}, state), {
        drafts: __spreadProps(__spreadValues({}, state.drafts), {
          create: getDefaultAsyncWrapperObj()
        })
      });
    case ACTION_TYPES$1.DRAFTS.RESET_DELETE:
      return __spreadProps(__spreadValues({}, state), {
        drafts: __spreadProps(__spreadValues({}, state.drafts), {
          delete: getDefaultAsyncWrapperObj()
        })
      });
    case ACTION_TYPES$1.DRAFTS.REMOVE:
      {
        const data = (_d = state.drafts.list) == null ? void 0 : _d.data;
        if (data) {
          const index = data == null ? void 0 : data.findIndex((item) => item.version === actionResult.payload);
          return __spreadProps(__spreadValues({}, state), {
            drafts: __spreadProps(__spreadValues({}, state.drafts), {
              list: __spreadProps(__spreadValues({}, state.drafts.list), {
                data: [...data.slice(0, index), ...data.slice(index + 1)]
              })
            })
          });
        }
      }
      break;
    case ACTION_TYPES$1.DRAFT.RESET_MERGE: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          merge: getDefaultAsyncWrapperObj()
        })
      });
    }
    case ACTION_TYPES$1.DRAFT.RESET_HISTORY: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          history: getDefaultAsyncWrapperObj()
        })
      });
    }
    case ACTION_TYPES$1.DRAFT.RESET_VALIDATE: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          validate: getDefaultAsyncWrapperObj(),
          validate_result: getDefaultAsyncWrapperObj()
        })
      });
    }
    case ACTION_TYPES$1.DRAFT.RESET_PUBLISH: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          publish: getDefaultAsyncWrapperObj(),
          publish_status: getDefaultAsyncWrapperObj()
        })
      });
    }
    case ACTION_TYPES$1.DRAFT.SEGMENTS_RESET_DELETE: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          segments: __spreadProps(__spreadValues({}, state.draft.segments), {
            delete: getDefaultAsyncWrapperObj()
          })
        })
      });
    }
    case ACTION_TYPES$1.DRAFT.SEGMENTS_REMOVE:
      {
        const data = (_e = state.draft.segments.list) == null ? void 0 : _e.data;
        if (data) {
          const filteredData = data == null ? void 0 : data.map((s) => ({ i: s.i, filePath: s.filePath })).filter(
            (s) => actionResult.payload.filter(
              (f) => f.name === s.i["@Name"] && f.filePath === s.filePath && f.level === s.i["@Level"]
            ).length === 0
          );
          return __spreadProps(__spreadValues({}, state), {
            draft: __spreadProps(__spreadValues({}, state.draft), {
              segments: __spreadProps(__spreadValues({}, state.draft.segments), {
                list: __spreadProps(__spreadValues({}, state.draft.segments.list), {
                  data: filteredData
                })
              })
            })
          });
        }
      }
      break;
    case ACTION_TYPES$1.DRAFT.SEGMENTS_RESET_CREATE: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          segments: __spreadProps(__spreadValues({}, state.draft.segments), {
            create_get: getDefaultAsyncWrapperObj(),
            create_put: getDefaultAsyncWrapperObj(),
            load: getDefaultAsyncWrapperObj()
          }),
          columns: __spreadProps(__spreadValues({}, state.draft.columns), {
            load: getDefaultAsyncWrapperObj()
          })
        })
      });
    }
    case ACTION_TYPES$1.DRAFT.SEGMENTS_ADD: {
      const data = (_f = state.draft.segments.list) == null ? void 0 : _f.data;
      if (data) {
        data.push(actionResult.payload);
        return __spreadProps(__spreadValues({}, state), {
          draft: __spreadProps(__spreadValues({}, state.draft), {
            segments: __spreadProps(__spreadValues({}, state.draft.segments), {
              list: __spreadProps(__spreadValues({}, state.draft.segments.list), {
                data
              })
            })
          })
        });
      }
      break;
    }
    case ACTION_TYPES.METRIC_METADATA_SET: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              metadata: actionResult.payload
            })
          })
        })
      });
    }
    case ACTION_TYPES.METRIC_METADATA_RESET: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              metadata: null
            })
          })
        })
      });
    }
    case ACTION_TYPES.METRIC_DETAILS_RESET: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              metric_details: getDefaultAsyncWrapperObj()
            })
          })
        })
      });
    }
    case ACTION_TYPES.METRIC_RESET_CREATE: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              [METRICS_REDUCER_KEYS.create_get]: getDefaultAsyncWrapperObj(),
              [METRICS_REDUCER_KEYS.create_put]: getDefaultAsyncWrapperObj(),
              metric_details: getDefaultAsyncWrapperObj(),
              quick_compile_put: getDefaultAsyncWrapperObj(),
              quick_compute_put: getDefaultAsyncWrapperObj(),
              quick_compute_get: getDefaultAsyncWrapperObj(),
              quick_compute_check: getDefaultAsyncWrapperObj(),
              quick_compute_cancel: getDefaultAsyncWrapperObj(),
              datasource_get: getDefaultAsyncWrapperObj(),
              datasource_details_get: getDefaultAsyncWrapperObj(),
              metadata: null,
              custom_dimensions: {}
            })
          })
        })
      });
    }
    case ACTION_TYPES.METRIC_QUICK_VALIDATE_RESET: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              quick_compute_get: getDefaultAsyncWrapperObj()
            })
          })
        })
      });
    }
    case ACTION_TYPES.CUSTOM_DIM_SET_ALL: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              custom_dimensions: __spreadValues(__spreadValues({}, state.draft.metrics.metric_wizard.custom_dimensions), actionResult.payload)
            })
          })
        })
      });
    }
    case ACTION_TYPES.CUSTOM_DIM_SET: {
      return __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              custom_dimensions: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard.custom_dimensions), {
                [actionResult.payload.id]: __spreadValues(__spreadValues({}, state.draft.metrics.metric_wizard.custom_dimensions[actionResult.payload.id]), actionResult.payload.customDimension)
              })
            })
          })
        })
      });
    }
    case ACTION_TYPES.CUSTOM_DIM_SET_USE: {
      const id = actionResult.payload.id;
      const component = actionResult.payload.component;
      const currentCustomDim = (_g = state.draft.metrics.metric_wizard.custom_dimensions[id]) == null ? void 0 : _g[component];
      const newCustomDim = { [actionResult.payload.component]: __spreadProps(__spreadValues({}, currentCustomDim), { inUse: actionResult.payload.inUse }) };
      return !currentCustomDim ? state : __spreadProps(__spreadValues({}, state), {
        draft: __spreadProps(__spreadValues({}, state.draft), {
          metrics: __spreadProps(__spreadValues({}, state.draft.metrics), {
            metric_wizard: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard), {
              custom_dimensions: __spreadProps(__spreadValues({}, state.draft.metrics.metric_wizard.custom_dimensions), {
                [actionResult.payload.id]: __spreadValues(__spreadValues({}, state.draft.metrics.metric_wizard.custom_dimensions[actionResult.payload.id]), newCustomDim)
              })
            })
          })
        })
      });
    }
  }
  return state;
};
export {
  MauiReducer,
  getDefaultState
};
//# sourceMappingURL=MauiReducer.js.map
